import * as tslib_1 from "tslib";
import { m } from '../hyperscript';
import { createContext } from '../ui/context';
import { View } from '../ui/view';
import { parseRoute } from './parseroute';
var _a = createContext(undefined), Provider = _a.Provider, Consumer = _a.Consumer;
export var Location = function (_a) {
    var children = _a.children;
    return (m(Consumer, null, function (location) {
        return location && children && children(location);
    }));
};
var pathnameMatcher = function (location, route) {
    return parseRoute(location.pathname, route);
};
var Router = /** @class */ (function (_super) {
    tslib_1.__extends(Router, _super);
    function Router() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Router.prototype.onCreate = function () {
        var _this = this;
        window.addEventListener('popstate', this.redraw);
        window.addEventListener('hashchange', this.redraw);
        this.onRemove = function () {
            window.removeEventListener('popstate', _this.redraw);
            window.removeEventListener('hashchange', _this.redraw);
        };
    };
    Router.prototype.render = function () {
        var _a = this.attrs, _b = _a.matcher, matcher = _b === void 0 ? pathnameMatcher : _b, _c = _a.formatPath, formatPath = _c === void 0 ? function (v) { return v; } : _c;
        var location = window.location, history = window.history;
        var protocol = location.protocol, hostname = location.hostname, port = location.port, search = location.search, hash = location.hash, pathname = location.pathname;
        return (m(Provider, { value: {
                protocol: protocol,
                hostname: hostname,
                port: port,
                search: search,
                hash: hash,
                pathname: pathname,
                replace: function (to) {
                    history.replaceState(pathname, '', to);
                    dispatchEvent(new PopStateEvent('popstate', { state: pathname }));
                },
                push: function (href) {
                    history.pushState(href, '', href);
                    dispatchEvent(new PopStateEvent('popstate', { state: href }));
                },
                match: function (route) { return matcher(location, route); },
                formatPath: formatPath
            } }, this.children));
    };
    return Router;
}(View));
export { Router };
